<template>
    <v-container fluid>
        <v-card class="px-5 p-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col class="flex-grow-1 d-flex align-center justify-start" >
                    <InfoBox expands
                        ><span class="titulo"></span>
                        As informações de <strong>Ativação, Categoria, Semana e Área</strong> são
                        exclusivas para a visão de Planejamento E-commerce.</InfoBox
                    >
                    <v-toolbar-title class="page-title ml-2"
                        >Gerencial Simulador</v-toolbar-title
                    >
                </v-col>
            </v-row>
            <filtro ref="filtro" @filtrar="filtrar" @limpar="limpar"></filtro>
        </v-card>
        <v-card class="px-5 py-3 my-5 br-15 w-100" elevation="0">
            <v-row class="mx-1 my-2 mb-3 mt-3">
                <v-col cols="3">
                    <Indicadores
                        titulo="PDV"
                        :valor="valoresIndicadores.pdv"
                        icone="mdi-store-outline"
                        :load="false"
                    />
                </v-col>
                <v-col cols="3">
                    <Indicadores
                        titulo="E-commerce"
                        :valor="valoresIndicadores.ecommerce"
                        icone="mdi-tag-outline"
                        :load="false"
                    />
                </v-col>
                <v-col cols="3">
                    <Indicadores
                        titulo="Campanha"
                        :valor="valoresIndicadores.campanha"
                        icone="mdi-shopping-outline"
                        :load="false"
                    />
                </v-col>
                <v-col cols="3">
                    <Indicadores
                        titulo="InvestimentoTotal"
                        :valor="investimentoTotal"
                        icone="mdi-currency-usd"
                        :load="false"
                    />
                </v-col>
            </v-row>
        </v-card>

        <!-- {{ $refs.filtro.filtro.planejado_realizado }} -->
        <v-card class="px-5 py-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col cols="6" class="py-4 px-4">
                    <v-toolbar-title class="grey--text"> </v-toolbar-title>
                </v-col>
                <v-col cols="6" align="end" class="py-2">
                    <v-btn
                        class="ml-2 my-1"
                        color="primary new-button"
                        @click="exportar()"
                    >
                        <v-icon left>mdi-microsoft-excel</v-icon> Exportar CSV
                    </v-btn>
                </v-col>
            </v-row>
            <div class="involucroGerencialSimulador">
                <v-data-table
                    :headers="headers"
                    :items="dados"
                    :items-per-page="5"
                    :footer-props="{
                        'items-per-page-options': [
                            5, 10, 15, 25, 50, 100, 500, -1,
                        ],
                        itemsPerPageText: 'Linhas por páginas',
                        ofText: 'de',
                        pageText: '{0}-{1} de {2}',
                    }"
                    class="tabela paginacao-esquerda flex-table"
                >
                    <template v-slot:header="{}">
                        <thead class="header0">
                            <tr>
                                <th
                                    v-for="(h, i) in headersGroup"
                                    :key="i"
                                    :colspan="h.colspan"
                                    :class="h.class"
                                    align="center"
                                >
                                    {{ h.text }}
                                </th>
                            </tr>
                        </thead>
                    </template>
                    <template
                        v-for="key in periodo"
                        v-slot:[`item.simulado-${key}`]="{ item }"
                    >
                        <div :key="key">
                            {{ formataMoeda(item[`simulado-${key}`]) }}
                        </div>
                    </template>
                    <template
                        v-for="key in periodo"
                        v-slot:[`item.realizado-${key}`]="{ item }"
                    >
                        <div :key="key">
                            {{ formataMoeda(item[`realizado-${key}`]) }}
                        </div>
                    </template>
                    <template
                        v-for="key in periodo"
                        v-slot:[`item.realxplan-${key}`]="{ item }"
                    >
                        <div :key="key">
                            {{ item[`realxplan-${key}`] || 0 }}%
                        </div>
                    </template>
                    <template
                        v-for="key in periodo"
                        v-slot:[`item.diff-${key}`]="{ item }"
                    >
                        <div
                            :class="
                                item[`diff-${key}`] < 0
                                    ? 'valor-negativo'
                                    : 'text-success'
                            "
                            :key="key"
                        >
                            {{ formataMoeda(item[`diff-${key}`]) }}
                        </div>
                    </template>
                    <template v-slot:[`body.append`]>
                        <tr class="table-footer">
                            <td class="text-center pl-4" :colspan="colspan">
                                Total:
                            </td>
                            <template v-for="key in periodo">
                                <td
                                    v-if="planejado_realizado"
                                    class="text-center"
                                    :key="'simulado-' + key"
                                >
                                    {{
                                        formataMoeda(
                                            somaColuna('simulado-' + key)
                                        )
                                    }}
                                </td>
                                <td
                                    class="text-center"
                                    :key="'realizado-' + key"
                                >
                                    {{
                                        formataMoeda(
                                            somaColuna('realizado-' + key)
                                        )
                                    }}
                                </td>
                                <td
                                    v-if="planejado_realizado"
                                    class="text-center"
                                    :key="'realxplan-' + key"
                                >
                                    {{
                                        mediaColuna(
                                            'simulado-' + key,
                                            'realizado-' + key
                                        ) + '%'
                                    }}
                                </td>
                                <td
                                    v-if="planejado_realizado"
                                    class="text-center"
                                    :key="'diff-' + key"
                                >
                                    {{
                                        formataMoeda(somaColuna('diff-' + key))
                                    }}
                                </td>
                            </template>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import Filtro from './Filtro.vue'
import Indicadores from './_components/Indicadores.vue'
import InfoBox from '../../components/InfoBox.vue'

// Rotulo das colunas de agrupamento que nao pode sair do nome do campo.
//
// O cabecalho da tabela e derivado da chave que o backend devolve (`grupo`),
// entao a padronizacao de nomenclatura nao chegou aqui: o filtro de colunas
// agrupadas tem o rotulo escrito a mao e ja dizia "Neogrupo", mas a tabela
// continuava mostrando "grupo". So o que muda de nome entra neste mapa; o
// resto segue derivado do campo, como antes.
//
// `subgrupo` nao e agrupavel no simulador hoje (nao existe em cols_agrupado
// nem no model), mas faz parte da mesma renomeacao e fica aqui para nao
// regredir caso passe a ser oferecido.
const ROTULOS_AGRUPAMENTO = {
    grupo: 'Neogrupo',
    subgrupo: 'Master categoria',
}

export default {
    name: 'ListaSimuladorGerencial',
    components: {
        Filtro,
        Indicadores,
        InfoBox,
    },
    data() {
        return {
            headers: [],
            dados: [],
            periodo: [],
            carregando: false,
            valoresIndicadores: {
                pdv: 0,
                ecommerce: 0,
                campanha: 0,
            },
            alerta: false,
            alertaTexto: '',
            alertaColor: 'error',
            alertaTimeout: 3000,
            colspan: 1,
            headersGroup: [],
            planejado_realizado: false,
            meses: [
                'Janeiro',
                'Fevereiro',
                'Março',
                'Abril',
                'Maio',
                'Junho',
                'Julho',
                'Agosto',
                'Setembro',
                'Outubro',
                'Novembro',
                'Dezembro',
            ],
        }
    },

    provide() {
        return {
            listaCampos: this.listaCampos(),
        }
    },
    mounted() {
        this.filtrar()
    },
    computed: {
        investimentoTotal() {
            return (
                this.valoresIndicadores.pdv +
                this.valoresIndicadores.ecommerce +
                this.valoresIndicadores.campanha
            )
        },
    },
    methods: {
        limpar() {
            this.valoresIndicadores = {
                pdv: 0,
                ecommerce: 0,
                campanha: 0,
            }

            this.filtrar()
        },
        async listaCampos() {
            // this.carregando = true

            var response = await this.$http().post(
                '/simulacao/gerencial/filtros',
                {}
            )

            // this.carregando = false

            return response.data
        },
        somaColuna(coluna) {
            let total = this.dados.reduce(
                (a, e) =>
                    (a += isNaN(parseFloat(e[coluna]))
                        ? 0
                        : parseFloat(e[coluna])),
                0
            )
            return total
        },
        mediaColuna(planejado, realizado) {
            let somaPlanejado = this.dados.reduce(
                (a, e) =>
                    (a += isNaN(parseFloat(e[planejado]))
                        ? 0
                        : parseFloat(e[planejado])),
                0
            )
            let somaRealizado = this.dados.reduce(
                (a, e) =>
                    (a += isNaN(parseFloat(e[realizado]))
                        ? 0
                        : parseFloat(e[realizado])),
                0
            )
            return Math.ceil((somaRealizado / somaPlanejado) * 100)
        },
        calcularIndicadores() {
            this.valoresIndicadores = {
                pdv: 0,
                ecommerce: 0,
                campanha: 0,
            }
            for (let dado of this.dados) {
                if (dado.visao === 'PDV') {
                    // confirma se é numero e soma se for
                    if (!isNaN(parseFloat(dado['realizado-total']))) {
                        this.valoresIndicadores.pdv += parseFloat(
                            dado['realizado-total']
                        )
                    }
                }
                if (dado.visao === 'Campanha') {
                    if (!isNaN(parseFloat(dado['realizado-total']))) {
                        this.valoresIndicadores.campanha += parseFloat(
                            dado['realizado-total']
                        )
                    }
                }
                if (dado.visao === 'Ecommerce') {
                    if (!isNaN(parseFloat(dado['realizado-total']))) {
                        this.valoresIndicadores.ecommerce += parseFloat(
                            dado['realizado-total']
                        )
                    }
                }
            }
        },
        async filtrar() {
            this.carregando = true
            const filtro = this.$refs.filtro.filtro

            const data = { ...filtro }

            if (data.agrupar && data.agrupar.length > 0) {
                data.agrupar = data.agrupar
                    .sort((a, b) => a.ordem - b.ordem)
                    .map((item) => item.value)
            }

            const response = await this.$http().post(
                '/simulacao/gerencial/lista',
                {
                    data: data,
                }
            )
            this.periodo = []
            this.calcPeriodo(filtro.dataInicial, filtro.dataFinal)
            this.dados = response.data
            this.dados = this.dados.map((item) => {
                item[`simulado-total`] = 0
                item[`realizado-total`] = 0
                item[`realxplan-total`] = 0
                item[`diff-total`] = 0
                this.periodo.forEach((periodo) => {
                    if (periodo !== 'total') {
                        item[`simulado-total`] +=
                            item[`simulado-${periodo}`] || 0
                        item[`realizado-total`] +=
                            item[`realizado-${periodo}`] || 0
                    }
                })
                item[`diff-total`] =
                    item[`realizado-total`] - item[`simulado-total`]
                const realxplan = Math.round(
                    (item['realizado-total'] / item['simulado-total']) * 100
                )
                item[`realxplan-total`] = isFinite(realxplan) ? realxplan : 0
                return item
            })
            this.calcularIndicadores()
            this.Mountheaders(filtro)
            this.carregando = false
        },

        async Mountheaders(filtros) {
            this.headersGroup = []
            this.headers = []
            this.periodo = []
            this.calcPeriodo(filtros.dataInicial, filtros.dataFinal)
            this.planejado_realizado = filtros.planejado_realizado
            this.headers.push({
                text: 'Visão',
                value: 'visao',
                align: 'center',
                class: 'th-separador',
            })
            // this.dados = [{ planejado: 1 }];]
            this.colspan = 1
            if (filtros.agrupar) {
                filtros.agrupar
                    .sort((a, b) => a.ordem - b.ordem)
                    .forEach((item) => {
                        const campo = item.value
                        if (campo == 'fornecedor') {
                            this.headers.push({
                                class: 'text-capitalize th-separador',
                                text: 'Código Fornecedor',
                                value: 'codigo',
                                align: 'center',
                            })
                            this.colspan++
                        }
                        this.headers.push({
                            class: 'text-capitalize th-separador',
                            text:
                                ROTULOS_AGRUPAMENTO[campo] ||
                                campo.replace(/_/g, ' '),
                            value: campo,
                            align: 'center',
                        })
                        this.colspan++
                    })
            }
            this.headersGroup.push({
                text: ``,
                colspan: this.colspan,
                class: 'whiteBG',
            })

            let contador = 0
            this.periodo.forEach((key) => {
                contador++
                const bg = contador % 2 === 0 ? 'bg-1' : 'bg-2'
                const [ano, mes] = key.split('-')
                const mesNome =
                    key === 'total'
                        ? 'Total do periodo selecionado'
                        : `${this.meses[mes - 1]} - ${ano}`
                this.headersGroup.push({
                    text: mesNome,
                    colspan: this.planejado_realizado ? 4 : 1,
                    align: 'center',
                    class: `headerMes text-center  ${bg}`,
                })
                if (this.planejado_realizado) {
                    this.headers.push({
                        text: 'Planejado',
                        value: `simulado-${key}`,
                        align: 'center',
                        class: `th-separador ${bg}`,
                    })
                    this.headers.push({
                        text: 'Realizado',
                        value: `realizado-${key}`,
                        align: 'center',
                        class: `th-separador ${bg}`,
                    })

                    this.headers.push({
                        text: 'Real VS Plan',
                        value: `realxplan-${key}`,
                        align: 'center',
                        class: `th-separador ${bg}`,
                    })
                    this.headers.push({
                        text: 'Diferença',
                        value: `diff-${key}`,
                        align: 'center',
                        class: ` ${bg}`,
                    })
                } else {
                    this.headers.push({
                        text: 'Realizado',
                        value: `realizado-${key}`,
                        align: 'center',
                        class: ` ${bg}`,
                    })
                }
            }) // Fim do forEach
        },
        calcPeriodo(dataInicial, dataFinal) {
            const [anoInicial, mesInicial] = dataInicial.split('-')
            const [anoFinal, mesFinal] = dataFinal.split('-')

            let ano = anoInicial
            while (ano <= anoFinal) {
                let mesInicio = +ano === +anoInicial ? mesInicial : 1
                let mesFim = +ano === +anoFinal ? mesFinal : 12
                this.periodo.push(
                    ...Array.from(
                        Array(mesFim - mesInicio + 1),
                        (_, i) => +ano + '-' + (i + Number(mesInicio))
                    )
                )
                ano++
            }
            this.periodo.push('total')
        },
        async exportar() {
            if (!this.$refs.filtro.validate()) return

            this.carregando = true
            const filtro = this.$refs.filtro.filtro
            if (filtro.agrupar) {
                filtro.agrupar = filtro.agrupar.map((item) => item.value)
            }

            var response = await this.$http().post(
                '/simulacao/gerencial/exportar',
                {
                    data: filtro,
                }
            )

            window.location = this.$http('baseURL') + response.data.url

            this.carregando = false
        },
        formataMoeda(valor = 0) {
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            })
        },
    },
}
</script>

<style>
.headerMes {
    background: var(--v-primary-base);
    text-align: center;
    border-left: thin solid rgba(0, 0, 0, 0.12);
    margin-left: auto;
    margin-right: auto;
    padding: 5px;
}
.valor-negativo {
    color: red;
    padding: 5px;
    padding: 5px;
}
.tabela-gerencial td,
.tabela-gerencial th {
    border-left: thin solid rgba(0, 0, 0, 0.1);
}
.involucroGerencialSimulador {
    height: 650px;
    display: flex;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
}

.involucroGerencialSimulador .flex-table {
    display: flex;
    flex-direction: column;
    height: 620px;
    width: 100%;
}

.involucroGerencialSimulador .flex-table > div {
    width: 100%;
}

.involucroGerencialSimulador thead {
    position: -webkit-sticky;
    position: sticky;
    overflow: hidden;
    z-index: 4;
}

.involucroGerencialSimulador .header0 {
    top: 0px;
    z-index: 4;
    border-bottom: 1px solid #e0e0e0;
}

.involucroGerencialSimulador .v-data-table-header {
    top: 48px;
    z-index: 4;
}

.involucroGerencialSimulador .v-data-table__wrapper {
    overflow-y: auto !important;
}

.whiteBG {
    background-color: white;
}

.bg-1 {
    background-color: var(--v-primary-base);
}

.bg-2 {
    background-color: var(--v-primary-lighten1);
}
</style>
